import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Search from '@ifeng-fe/ui_pc_search';
import { Chip } from '@ifeng-fe/visualediting';
import { ChipMap } from '@src/pc/index/chipMap';

const Header = (props) => {
    const { searchData } = props;

    return (
        <div className={styles.header}>
            <div className={styles.left}>
                <a href="https://finance.ifeng.com" target="_blank" style={{ lineHeight: 0 }}>
                    <img className={styles.logo} src="https://p0.ifengimg.com/37780e23b9ea2d8b/2017/38/logoFinance.png" alt="finance" />
                </a>
                <div className={styles.home}>
                    <a href="https://www.ifeng.com">凤凰网首页</a>
                    <span className={styles.divider}>|</span>
                    <a href="https://finance.ifeng.com">财经首页</a>
                </div>
                <div className={styles.links}>
                    [<a href="">资讯</a>]
                    [<a href="">评论</a>]
                    [<a href="">股票</a>]
                    [<a href="">理财</a>]
                    [<a href="">基金</a>]
                </div>
            </div>
            <div>
                <Chip key="Search" {...ChipMap.Search} content={searchData}>
                    <Search />
                </Chip>
            </div>
        </div>
    );
};

Header.propTypes = {
    searchData: PropTypes.array
};

export default errorBoundary(Header);
